import type { ReactNode } from 'react'
import styles from './FormField.module.css'

export interface FormFieldProps {
  label: string
  error?: string
  htmlFor?: string
  children: ReactNode
  className?: string
}

export function FormField({ label, error, htmlFor, children, className }: FormFieldProps) {
  const classes = [styles.field, className].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      <label className={styles.label} htmlFor={htmlFor}>{label}</label>
      {children}
      {error && <span className={styles.error}>{error}</span>}
    </div>
  )
}
